import styled from "styled-components";

export const Box = styled.div`

.interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  .imgopt-container {
    font-family: system-ui, -apple-system, sans-serif;
    padding: 2rem;
  }

  .imgopt-card {
    background-color: white;
    border-radius: 1rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
  }

  .imgopt-title {
    font-size: 1.875rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .imgopt-upload-area {
    border: 2px dashed #d1d5db;
    border-radius: 0.75rem;
    padding: 2rem;
    text-align: center;
    transition: all 0.2s;
  }

  .imgopt-upload-area.dragging {
    border-color: #3b82f6;
    background-color: #eff6ff;
  }

  .imgopt-upload-icon {
    width: 3rem;
    height: 3rem;
    color: #9ca3af;
    margin-bottom: 1rem;
  }

  .imgopt-upload-text {
    color: #4b5563;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
  }

  .imgopt-upload-hint {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .imgopt-browse-button {
    color: #3b82f6 !important;
    background: none !important;
    border: none !important;
    font-weight: 500;
  }

  .imgopt-browse-button:hover {
    color: #2563eb !important;
  }

  .imgopt-settings {
    margin-top: 2rem;
  }

  .imgopt-settings-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .imgopt-settings-grid {
    gap: 1rem;
  }

  .imgopt-form-group {
    margin-bottom: 1rem;
  }

  .imgopt-form-label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
  }

  .imgopt-form-control {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 0.875rem;
  }

  .imgopt-form-control:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .imgopt-image-list {
    margin-top: 2rem;
  }

  .imgopt-image-item {
    background-color: #f9fafb;
    border-radius: 0.5rem;
    padding: 1rem;
    margin-bottom: 1rem;
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .imgopt-image-preview {
    width: 12rem;
    height: 12rem;
    flex-shrink: 0;
  }

  .imgopt-image-preview img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .imgopt-image-info {
    flex-grow: 1;
  }
  .imgconv-container {
  padding: 0px !important;
  }

  .imgopt-image-name {
    font-weight: 500;
    color: #111827;
    margin-bottom: 0.5rem;
  }

  .imgopt-image-size {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .imgopt-optimized-size {
    font-size: 0.875rem;
    color: #000000ff;
  }

  .imgopt-error-size {
    font-size: 0.875rem;
    color: #ef4444;
  }

  .imgopt-error-note {
    font-size: 0.875rem;
    color: #ef4444;
    font-style: italic;
  }

  .imgopt-button {
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    font-weight: 500;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: background-color 0.2s;
  }

  .imgopt-button-primary {
    background-color: #8CC540;
    color: white;
  }

  .imgopt-button-primary:hover {
    background-color: #84b93fff;
  }

  .imgopt-button-success {
    background-color: #8CC540;
    color: white;
  }

  .imgopt-button-success:hover {
    background-color: #8CC540;
  }

  .imgopt-button-danger {
    color: #ef4444;
    background: none;
  }

  .imgopt-button-danger:hover {
    color: #dc2626;
  }

  .imgopt-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 1rem;
  }

  .imgopt-hidden {
    display: none;
  }

  @media (max-width: 768px) {
    .imgopt-container {
      padding: 0.25rem !important;
    }

    .imgopt-card {
      padding: 15px !important; 
      margin: 0 !important;     
      border-radius: 0.5rem;
    }

    .imgopt-title {
      font-size: 1.25rem !important;
      margin-bottom: 0.5rem !important;
    }

    .imgopt-upload-area {
      padding: 0.75rem !important;
    }

    .imgopt-image-item {
      flex-direction: column !important;
      align-items: center !important;
      text-align: center;
      padding: 0.75rem !important;
    }

    .imgopt-image-preview {
      width: 100% !important;
      max-width: 250px;
      height: auto !important;
      margin-bottom: 0.5rem;
    }

    .imgopt-actions {
      justify-content: center;
      gap: 0.25rem !important;
    }

    .imgopt-button {
      padding: 0.4rem 0.75rem !important;
      font-size: 0.75rem !important;
    }

    .imgopt-settings {
      margin-top: 0.5rem !important;
    }
      .imgopt-settings-grid {
    gap: 0.5rem !important;
  }

  .imgopt-form-group {
    margin-bottom: 0.5rem !important;
  }
  }
`;
